export const ActionTypes = {
    ADD_TO_CART : 'ADD_TO_CART',
    REMOVE_FROM_CART: 'REMOVE_FROM_CART',
    ADJUST_QTY : 'ADJUST_QTY',
    CLEAR_ROOM_CART : 'CLEAR_ROOM_CART',
    SET_QTY_ZERO : 'SET_QTY_ZERO'
}